module.exports = __webpack_public_path__ + "img/1028.e093ad7c.gif";